import { useSuspenseQuery } from '@tanstack/react-query'

import { contractQueries } from '@/entities/contract'

export const useSimpleReviewTemplates = () => {
  const { data } = useSuspenseQuery(contractQueries.simpleReviewTemplates())

  const templateIds = data.map(template => template.id)

  return {
    simpleReviewTemplates: data,
    templateIds,
  }
}
